// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";

Vue.config.productionTip = false
//Vue.config.devtools = true
Vue.use(VueSweetalert2);
Vue.use(VueI18n);

import global_ from '@/components/Global';
Vue.prototype.GLOBAL = global_

import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
  config: { id: "UA-122682731-1" }
});

const messages = {
  zh_tw: {
    "有新版本!": "有新版本!",
    "請前往APP商店進行更新": "請前往APP商店進行更新",
    "立即前往": "立即前往",
    "更新已準備好, 按下「立即更新」後將重新載入APP": "更新已準備好, 按下「立即更新」後將重新載入APP",
    "立即更新": "立即更新",
  },
  en: {
    "有新版本!": "New Version!",
    "請前往APP商店進行更新": "Please go to App Store to update",
    "立即前往": "Open App Store",
    "更新已準備好, 按下「立即更新」後將重新載入APP": "The update is ready, click 「Update Now」 to reload APP",
    "立即更新": "Update Now",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

/* eslint-disable no-new */
var app = new Vue({
  el: '#app',
  i18n,
  router,
  components: { App },
  template: '<App/>',
  mounted: function () {
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
  },
  methods: {
    init: function () {
      if (typeof window.screen != 'undefined') {
        window.screen.orientation.lock('portrait');
      }

      // 比較目前版本與遠端版本
      function compareVersion(serverVersion) {
        return new Promise((resolve, reject) => {
          window.chcp.getVersionInfo((error, data) => {
            console.log('getVersionInfo', data);
            console.log(data.currentWebVersion);
            console.log(serverVersion);
            if (error) {
              reject(error)
            } else {
              resolve(data.currentWebVersion === serverVersion);
            }
          });
        });
      }

      // 判斷版本
      function checkUpdate() {
        var nowDate = new Date();
        let urlSrc = Vue.prototype.GLOBAL.apiSrc + "/chcp.json?v=" + nowDate.getTime();

        fetch(urlSrc).then(res => res.json()).then(data => compareVersion(data.release)).then(isEqual => {
          if (isEqual) {
            console.log('checkUpdate 已是最新版本');
            //toast('已是最新版');
            // 載入LINE登入
            if (typeof cordova != 'undefined') {
              lineLogin.initialize({ channel_id: "1660744776" });
            }
          } else {
            // 確認新版本
            checkAvalilable();
          }
        }).catch((error) => {
          console.log('checkUpdate failed', error)
        });

      }

      // 確認新版本是否存在並開始更新
      function checkAvalilable() {
        console.log('checkAvalilable');
        window.chcp.isUpdateAvailableForInstallation((error, data) => {
          if (error) {
            console.log('isUpdateAvailableForInstallation error', error);
            checkHotUpdate();
            return;
          }
          // 已有可安装版本
          beforeInstallAlert();
        });
      }

      // 開始取得更新
      function checkHotUpdate() {
        console.log('checkHotUpdate');
        const waitingId = setTimeout(() => {
          console.log('checkHotUpdate 有新版本, 開始更新');
          //toast('有新版，开始更新');
          Vue.swal({
            title: "資料同步中請稍候...",
            allowOutsideClick: false,
            showConfirmButton: false,
            willOpen: function () {
              Vue.swal.showLoading();
            },
          });
        }, 200);
        window.chcp.fetchUpdate((error, data) => {
          if (error) {
            console.log('fetchUpdate error', error);
            clearTimeout(waitingId);
            if (error.code == 2) {
              console.log('checkHotUpdate 已是最新版本');
              //toast('已是最新版');
              Vue.swal.close();
            } else if (error.code == -17) {
              console.log('checkHotUpdate 更新下載中');
              //toast('正在下载更新中...');
              Vue.swal.close();
            } else if (error.code == -2) {
              console.log('checkHotUpdate 需更新APK');
              // 需要下载apk
              Vue.swal({
                title: "有新版本!",
                text: "請前往APP商店進行更新",
                icon: "info",
                allowOutsideClick: false,
                confirmButtonText: "立即前往",
              }).then((result) => {
                cordova.getAppVersion.getPackageName(function (pkgname) {
                  if (device.platform == "iOS") {
                    // if (pkgname == "tw.thinker.enjoykaohsiung") {
                    //   alert("開發版本僅可透過TestFlight進行更新");
                    // } else {
                    //   cordova.InAppBrowser.open(
                    //     "itms-apps://itunes.apple.com/app/id1587469410",
                    //     "_system"
                    //   );
                    // }
                    cordova.InAppBrowser.open(
                      "itms-apps://itunes.apple.com/app/id1415685647",
                      "_system"
                    );
                    //window.open("itms-apps://itunes.apple.com/app/id1587469410"); // MeN Go Plus
                    //window.open("itms-apps://itunes.apple.com/app/id1415685647"); // MeN Go
                  } else {
                    cordova.InAppBrowser.open(
                      "market://details?id=" + pkgname,
                      "_system"
                    );
                  }
                });
              });
            } else {
              console.log('checkHotUpdate 發生錯誤(' + error.code + ')');
              //toast(`出错了: ${error.code}`);
              Vue.swal.close();
            }
            return;
          }
          // 取得版本訊息
          //console.log('fetchUpdate data', data);
          // JSON解析
          //const config = data && data.config && JSON.parse(data.config);
          //console.log('fetchUpdate config', config);
          // 下載完成後呼叫視窗
          beforeInstallAlert();
        });
      }

      function beforeInstallAlert() {
        //console.log('beforeInstallAlert 這邊要跳視窗');
        installUpdate();
        // Vue.swal({
        //   title: "有新版本!",
        //   text: "更新已準備好, 按下「立即更新」後將重新載入APP",
        //   icon: "info",
        //   allowOutsideClick: false,
        //   confirmButtonText: "立即更新",
        //   willClose: function () {
        //     installUpdate();
        //   },
        // });
      }

      // 安裝更新行為
      function installUpdate() {
        window.chcp.installUpdate((error) => {
          if (error) {
            Vue.swal({
              title: "資料同步失敗",
              text: "很抱歉, 同步過程發生錯誤(錯誤代碼: " + error.code + "), 若持續發生此問題請卸載並重新安裝APP, 造成不便敬請見諒",
              icon: "info",
              allowOutsideClick: false,
              confirmButtonText: "確認"
            });
            console.log('installUpdate error', error);
            //toast(`安装失败: ${error.code}`);
            return;
          }
          Vue.swal.close();
          console.log('installUpdate done');
        });
      }

      // 開始判斷版本
      checkUpdate();

      function trySomeTimes(asyncFunc, onSuccess, onFailure, customTries) {
        var tries = typeof customTries === "undefined" ? 100 : customTries;
        var interval = setTimeout(function () {
          if (typeof asyncFunc !== "function") {
            onSuccess("Unavailable");
            return;
          }
          asyncFunc()
            .then(function (result) {
              if ((result !== null && result !== "") || tries < 0) {
                onSuccess(result);
              } else {
                trySomeTimes(asyncFunc, onSuccess, onFailure, tries - 1);
              }
            })
            .catch(function (e) {
              clearInterval(interval);
              onFailure(e);
            });
        }, 100);
      }

      function logFCMToken() {
        if (device.platform == "Android") {
          FCM.subscribeToTopic("allAndroid");
        }
        trySomeTimes(
          FCM.getToken,
          function (token) {
            console.log("Started listening FCM as " + token);
            if (Storage.isKey("ek_login_token")) {
              $.ajax({
                url: Vue.prototype.GLOBAL.apiSrc + Vue.prototype.GLOBAL.subDirectory + "/Htmlv2/PushTokenUpdate",
                type: "post",
                data: {
                  token: Storage.get("ek_login_token"),
                  fcmToken: token,
                  apnsToken: ''
                },
                dataType: "json",
                error: function () { },
                success: function (res) {
                  if (res.tester) {
                    FCM.subscribeToTopic("tester");
                  }
                },
              });
            }
          },
          function (error) {
            console.log("Error on listening for FCM token: " + error);
          }
        );
      }

      function logAPNSToken() {
        if (device.platform !== "iOS") {
          return;
        }
        FCM.subscribeToTopic("alliOS");
        FCM.getAPNSToken(
          function (token) {
            console.log("Started listening APNS as " + token);
            if (Storage.isKey("ek_login_token")) {
              $.ajax({
                url: Vue.prototype.GLOBAL.apiSrc + Vue.prototype.GLOBAL.subDirectory + "/Htmlv2/PushTokenUpdate",
                type: "post",
                data: {
                  token: Storage.get("ek_login_token"),
                  fcmToken: '',
                  apnsToken: token
                },
                dataType: "json",
                error: function () { },
                success: function (res) {
                  if (res.tester) {
                    FCM.subscribeToTopic("tester");
                  }
                },
              });
            }
          },
          function (error) {
            console.log("Error on listening for APNS token: " + error);
          }
        );
      }

      function waitForPermission(callback) {
        FCM.requestPushPermission()
          .then(function (didIt) {
            if (didIt) {
              callback();
            } else {
              console.log("Push permission was not given to this application");
            }
          })
          .catch(function (error) {
            console.log("Error on checking permission: " + error);
          });
      }

      function logFCMToken_NEW() {
        if (device.platform == "Android") {
          cordova.plugins.firebase.messaging.subscribe("allAndroid");
        }
        cordova.plugins.firebase.messaging.getToken().then(function (token) {
          console.log("Started listening FCM as " + token);
          if (Storage.isKey("ek_login_token")) {
            $.ajax({
              url: Vue.prototype.GLOBAL.apiSrc + Vue.prototype.GLOBAL.subDirectory + "/Htmlv2/PushTokenUpdate",
              type: "post",
              data: {
                token: Storage.get("ek_login_token"),
                fcmToken: token,
                apnsToken: ''
              },
              dataType: "json",
              error: function () { },
              success: function (res) {
                if (res.tester) {
                  cordova.plugins.firebase.messaging.subscribe("tester");
                }
              },
            });
          }
        });
      }

      function logAPNSToken_NEW() {
        if (device.platform !== "iOS") {
          return;
        }
        cordova.plugins.firebase.messaging.subscribe("alliOS");
      }

      function waitForPermission_NEW(callback) {
        cordova.plugins.firebase.messaging.requestPermission({ forceShow: true }).then(function () {
          console.log("Push messaging is allowed");
        });
      }

      function logHasPermissionOnStart() {
        FCM.hasPermission().then(function (hasIt) {
          console.log("Started with permission: " + JSON.stringify(hasIt));
        });
      }

      function handlePushAction(data) {
        switch (parseInt(data.type)) {
          case 1:
            router.push({ name: 'Category', params: { CId: data.cid } });
            break;
          case 2:
            router.push({ name: 'Post', params: { PId: data.pid } });
            break;
          case 3:
            if (window.cordova && cordova.InAppBrowser) {
              cordova.InAppBrowser.open(
                data.url,
                "_blank",
                "location=no,hardwareback=no,footer=yes,closebuttoncaption=Close,closebuttoncolor=#ffffff"
              );
            } else {
              window.open(data.url, "_system");
            }
            break;
        }
      }

      if (typeof cordova != 'undefined') {
        // FCM Check
        if (typeof FCM != 'undefined') {
          console.log("Has FCM");
          logHasPermissionOnStart();
          waitForPermission(function () {
            console.log("Push permission was given");
          });
          logFCMToken();
          logAPNSToken();
          FCM.subscribeToTopic("allDevices");
        } else {
          console.log("No FCM");
          waitForPermission_NEW(function () {
            console.log("Push permission was given");
          });
          logFCMToken_NEW();
          logAPNSToken_NEW();
          cordova.plugins.firebase.messaging.subscribe("allDevices");
          cordova.plugins.firebase.messaging.onBackgroundMessage(function (payload) {
            if (payload && payload.type) {
              handlePushAction(payload);
            }
          });
          cordova.plugins.firebase.messaging.onMessage(function (payload) {
            if (payload && payload.gcm && payload.gcm.body) {
              Vue.swal({
                title: "推播通知",
                text: payload.gcm.body,
                //icon: "info",
                allowOutsideClick: false,
                confirmButtonText: "前往查看",
                cancelButtonText: "我知道了",
                showCancelButton: true,
                showConfirmButton: payload.type && payload.type != 0
              }).then((result) => {
                if (result.isConfirmed) {
                  handlePushAction(payload);
                }
              });
            }
          });
        }

        // 取得位置(僅Android)
        if (device.platform == "Android") {
          // 定位權限
          var permissions = cordova.plugins.permissions;
          var list = [
            permissions.ACCESS_COARSE_LOCATION,
            permissions.ACCESS_FINE_LOCATION,
            permissions.ACCESS_LOCATION_EXTRA_COMMANDS,
          ];
          permissions.checkPermission(list, success, null);
          function error() {
            console.warn("Permission is not turned on");
          }
          function success(status) {
            if (!status.hasPermission) {
              permissions.requestPermissions(
                list,
                function (status) {
                  if (!status.hasPermission) {
                    error();
                  } else {
                    cordova.plugins.locationAccuracy.canRequest(function (canRequest) {
                      if (canRequest) {
                        cordova.plugins.locationAccuracy.request(function (success) {
                          console.log("Successfully requested accuracy: " + success.message);
                        }, function (error) {
                          console.error("Accuracy request failed: error code=" + error.code + "; error message=" + error.message);
                          if (error.code !== cordova.plugins.locationAccuracy.ERROR_USER_DISAGREED) {
                            if (window.confirm("Failed to automatically set Location Mode to 'High Accuracy'. Would you like to switch to the Location Settings page and do this manually?")) {
                              cordova.plugins.diagnostic.switchToLocationSettings();
                            }
                          }
                        }, cordova.plugins.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY);
                      } else {
                        // request location permission and try again
                      }
                    });
                  }
                },
                error
              );
            }
          }
          // Implement this in `deviceready` event callback
          // AdvancedGeolocation.start(
          //   function (success) {
          //     try {
          //       var jsonObject = JSON.parse(success);
          //       switch (jsonObject.provider) {
          //         case "gps":
          //           if (jsonObject.latitude != "0.0") {
          //             console.log("GPS location detected - lat:" +
          //               jsonObject.latitude + ", lon: " + jsonObject.longitude +
          //               ", accuracy: " + jsonObject.accuracy);
          //             Vue.$cookies.set("lat", jsonObject.latitude);
          //             Vue.$cookies.set("lon", jsonObject.longitude);
          //           }
          //           break;
          //       }
          //     }
          //     catch (exc) {
          //       console.log("Invalid JSON: " + exc);
          //     }
          //   },
          //   function (error) {
          //     console.log("ERROR! " + JSON.stringify(error));
          //   },
          //   ////////////////////////////////////////////
          //   //
          //   // REQUIRED:
          //   // These are required Configuration options!
          //   // See API Reference for additional details.
          //   //
          //   ////////////////////////////////////////////
          //   {
          //     "minTime": 500,         // Min time interval between updates (ms)
          //     "minDistance": 1,       // Min distance between updates (meters)
          //     "noWarn": true,         // Native location provider warnings
          //     "providers": "gps",     // Return GPS, NETWORK and CELL locations
          //     "useCache": true,       // Return GPS and NETWORK cached locations
          //     "satelliteData": false, // Return of GPS satellite info
          //     "buffer": false,        // Buffer location data
          //     "bufferSize": 0,        // Max elements in buffer
          //     "signalStrength": false // Return cell signal strength data
          //   }
          // );
        }
      }
    },
    onResume: function () {
      if (window.location.href.indexOf('QRCode') !== -1 || window.location.href.indexOf('MQRCode') !== -1) {
        // QRCODE需重整
        Storage.set("needReloadQRCode", "1");
        // 若為手機需調整亮度
        if (typeof cordova != 'undefined' && device.platform == "Android") {
          var LightControl = cordova.plugins.brightness;
          LightControl.setBrightness(
            1,
            function success() { },
            function error() { }
          );
        }
      }
    },
    onPause: function () {
      if (window.location.href.indexOf('QRCode') !== -1 || window.location.href.indexOf('MQRCode') !== -1) {
        // 若為手機需調整亮度
        if (typeof cordova != 'undefined' && device.platform == "Android") {
          var LightControl = cordova.plugins.brightness;
          LightControl.setBrightness(
            -1,
            function success() { },
            function error() { }
          );
        }
      }
    },
    onActive: function () {
      if (window.location.href.indexOf('QRCode') !== -1 || window.location.href.indexOf('MQRCode') !== -1) {
        // 若為手機需調整亮度
        if (typeof cordova != 'undefined' && device.platform == "iOS") {
          var LightControl = cordova.plugins.brightness;
          LightControl.setBrightness(
            1,
            function success() { },
            function error() { }
          );
        }
      }
    },
    onResign: function () {
      if (window.location.href.indexOf('QRCode') !== -1 || window.location.href.indexOf('MQRCode') !== -1) {
        // 若為手機需調整亮度
        if (typeof cordova != 'undefined' && device.platform == "iOS") {
          var LightControl = cordova.plugins.brightness;
          LightControl.setBrightness(
            0.6,
            function success() { },
            function error() { }
          );
        }
      }
    },
  }
})

document.addEventListener('deviceready', app.init, true);
document.addEventListener('resume', app.onResume, true);
document.addEventListener('pause', app.onPause, true);
document.addEventListener('active', app.onActive, true);
document.addEventListener('resign', app.onResign, true);
//document.addEventListener('backbutton', app.backPressed, false);

router.beforeEach((to, from, next) => {
  // 判斷是否在cordova環境中再決定是否自動調整亮度
  if (typeof cordova != 'undefined') {
    if (device.platform == "iOS" || device.platform == "Android") {
      var LightControl = cordova.plugins.brightness;
      // 判斷進入頁面
      if (to.name == "QRCode" || to.name == "MQRCode") {
        LightControl.setBrightness(
          1,
          function success() { },
          function error() { }
        );
      } else {
        if (device.platform == "iOS") {
          LightControl.setBrightness(
            0.6,
            function success() { },
            function error() { }
          );
        } else {
          LightControl.setBrightness(
            -1,
            function success() { },
            function error() { }
          );
        }
      }
    }
  }
  // else {
  //   if (to.name == "Map") {
  //     // 需要下载apk
  //     Vue.swal({
  //       title: "體驗更多功能",
  //       text: "下載APP體驗更多",
  //       icon: "info",
  //       allowOutsideClick: false,
  //       confirmButtonText: "立即前往",
  //     }).then((result) => {
  //       console.log(result)
  //     });
  //     return false;
  //   }
  // }
  // 判斷若是前往註冊或登入畫面要先檢查是否已登入
  if ((to.name == "Login" || to.name == "Register" || to.name == "Forget") && Storage.isKey("ek_login_token")) {
    // 返回首頁
    next({ name: 'Home' });
  } else {
    next();
  }
})

router.afterEach((to, from) => {
  // 取得記錄
  var routerHistory = [];
  if (Storage.isKey("routerHistory")) {
    var routerHistoryInfo = Storage.get("routerHistory");
    if (typeof routerHistoryInfo == "object") {
      routerHistory = routerHistoryInfo;
    } else {
      routerHistory = JSON.parse(routerHistoryInfo);
    }
  }
  // 目標是首頁就清空
  if (to.name == "Home") {
    routerHistory = [];
  } else {
    routerHistory.push(from.path);
  }
  Storage.set("routerHistory", JSON.stringify(routerHistory));
})

router.afterEach((to, from, next) => {
  // 重新讀取畫面
  //location.reload();
  // window.pageYOffset = 0
  // window.scrollTo(0, 0)
  // document.body.scrollTop = 0
  // document.documentElement.scrollTop = 0;
  console.log(from.fullPath + '=>' + to.fullPath)

  if (from.name != to.name && to.fullPath != '/') {
    $("#App").attr("class", "wrapper");
    if ($(".package-check").hasClass("slick-initialized")) {
      $(".package-check").slick("unslick");
    }
  } else if (to.fullPath == '/') {
    location.reload();
  }

  // if (from.name != to.name) {
  //   $("#App").attr("class", "wrapper");
  //   if ($(".package-check").hasClass("slick-initialized")) {
  //     $(".package-check").slick("unslick");
  //   }
  // }
})

Vue.directive('select2', {
  inserted(el, binding, vnode) {
    const options = Object.assign({
      width: '100%',
      language: 'zh-TW',
      placeholder: binding.value.placeholder || '請選擇',
      allowClear: true
    }, binding.value || {});

    $(el).select2(options);

    $(el).on('select2:select select2:unselect', () => {
      const event = new Event('change', { bubbles: true });
      el.dispatchEvent(event);
    });

    // Initial value setting
    if (binding.value.value !== undefined) {
      $(el).val(binding.value.value).trigger('change');
    }

    if (vnode.context[binding.expression]) {
      $(el).val(vnode.context[binding.expression]).trigger('change');
    }
  },
  update(el, binding, vnode) {
    $(el).val(binding.value.value).trigger('change');
  },
  componentUpdated(el, binding, vnode) {
    $(el).val(binding.value.value).trigger('change');
  },
  unbind(el) {
    $(el).select2('destroy');
  }
});


// WEBPACK FOOTER //
// ./src/main.js